import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/search/searchbox_result.html";
import "bootstrap/bootstrap-tagsinput";

$(function() {
    $(markup).appendTo($("body"));
});

uly.fq_parser = function(context){
    this.$conditional = new RegExp(/^(\!{0,1}\$[^{]+)/g);
    this.$cond_variables = new RegExp(/(\!{0,1}\$([\w\d_.])+)/g);
    this.$variables = new RegExp(/(\!{0,1}\$\{[\w\d_.]+\})/g);
    this.expressions = new RegExp(/(\!{0,1}\${1}).+?\{.+?\};|\{.+?\};/g);
    this.filters = new RegExp(/(\{)(.+?)(\};)/g);
    this.$prefix = new RegExp(/^(\!{0,1})(\$\{?)([^\}]+)(}?)/);
    this.normalized_prefix = {"parent":"$parent", "data":"$data"};
    this.normalized_method = {
        "!":function(value){
            if (value == null || value == undefined)
                return true;
            switch(value.typeof()){
            case "Boolean":
            case "String":
                return !value;
                break;
            case "Array":
                return !value.length;
                break;
            case "Function":
                return !value();
                break;
            default:
                return null;
            }
        }
    };
    this.denormalize = function(value){
        if (value == null || value == undefined)
            return null ;
        switch(value.typeof()){
        case "Boolean":
            return value;
            break;
        default:
            return "'" + value + "'";
        }
    };
    this.fq = [];
    this.context = context;
    var evaluate_expression = function(text){
        return eval(text);
    };
    this.cleanup_variable = function(variable){
        var prefix = variable.match(this.$prefix),
            methods = [], prefixs = [];
        variable = variable.replace(this.$prefix, "$3");
        for (var p=1; p <prefix.length;p++){
            var tokens = prefix[p] ? prefix[p].split(".") : [];
            var final_tokens = [];
            for (var i=0;i<tokens.length;++i) {
                var token = tokens[i];
                if (token && token in this.normalized_prefix){
                    prefixs.push(this.normalized_prefix[token]);
                }else if(token && token in this.normalized_method){
                    methods.push(token);
                }
                else final_tokens.push(token);
            }
            if (p == 3) { variable = final_tokens.join("."); }
        }
        if (!prefixs.length)
            prefixs.push("$data");
        prefixs.push("$context");
        return {variable:variable, methods:methods, prefixs:prefixs};
    };
    this.evaluate_var = function(variable, denormalized){
        var tmp = this.cleanup_variable(variable);
        var rewrittenBindings = ko.expressionRewriting.preProcessBindings("text:"+tmp.variable, {valueAccessors:false});
        var tmp_function = "return{" + rewrittenBindings + "}";
        for (var p=0; p <tmp.prefixs.length;p++){
            tmp_function = "with("+tmp.prefixs[p]+"){"+tmp_function+"}";
        }
        var f = new Function("$context", tmp_function);
        var tmp_result = null;
        if(tmp.methods.length){
            for (var m in tmp.methods){
                tmp_result = this.normalized_method[tmp.methods[m]](tmp_result == null ? ko.unwrap(f(this.context).text): tmp_result);
            }
        }else{
            try {
                var co = f(this.context);
                if (co) {
                    tmp_result = ko.unwrap(co.text);
                }
            }
            catch(e) {
                console.error(e);
                tmp_result = null;
            }
        }
        return denormalized ? this.denormalize(tmp_result) : tmp_result;
    };
    this.replace_var = function(variables, text, denormalized){
        if (variables && variables.length)
            for (var v=0;v<variables.length;v++){
                text = text.replace(variables[v], this.evaluate_var(variables[v], denormalized));
            }
        return text;
    };
    this.extract_var = function(text, conditional_step){
        var expr = this.$variables;
        if (conditional_step)
            expr = this.$cond_variables;
        if (expr.test(text)){
            var variables = text.match(expr);
            return variables;
        }
        return [];
    };
    this.create_fq = function(text){
        if (!this.filters.test(text))
            return "";
        var filters = text.match(this.filters),
            tmp = "";
        for (var f = 0; f < filters.length;f++){
            var filter = filters[f];
            var n_filter = filter.replace(this.filters, "$2");
            tmp += this.replace_var(this.extract_var(n_filter), n_filter);
        }
        return tmp;
    };
    this.toString = function(){
        return this.fq.join(" AND ");
    };
    this.parse = function(text){
        if(!text)
            return text;
        this.fq = [];
        var matching_expressions = text.match(this.expressions);
        if (matching_expressions && matching_expressions.length){
            for (var i = 0; i < matching_expressions.length;i++){
                var match = matching_expressions[i];
                if(this.$conditional.test(match)){
                    var $cond = match.match(this.$conditional);
                    $cond = $cond[0];
                    if (evaluate_expression(
                        this.replace_var(
                            this.extract_var($cond, true), $cond, true
                        )
                    )){
                        this.fq.push(this.create_fq(match.replace($cond, "")));
                    }
                }else{
                    this.fq.push(this.create_fq(match));
                }
            }
            return this.toString();
        }
        return text;
    };
    return this;
};

function on_value_selected(e, other, multi_conf, id_obs, value, reset, bindings, $elt) {
    var params = { val:e.val, added:e.added, removed:e.removed };
    if (other) {
        params = $.extend(params, other);
    }
    var newval = params.val;
    var added = params.added;
    var removed = params.removed;
    if (multi_conf) {
        if(added) {
            if(Object.isObject(added))
                added = [added];
            $.each(added, function(idx,val) {
                if (id_obs) {
                    id_obs.push(ko.unwrap(val.id));
                }
                value.push({"id":val.id, "name":val.title || val.name, "unique_id":val.unique_id });
            });
        }
        if (removed) {
            if(Object.isObject(removed))
                removed = [removed];
            var vals = ko.unwrap(value);
            var ids = id_obs? ko.unwrap(id_obs) : null;
            $.each(ko.toJS(removed), function(idx,val) {
                for (var i = vals.length -1; i>=0;--i)
                {
                    if (val && ko.unwrap(vals[i].id) == ko.unwrap(val.id))
                        value.splice(i,1);

                }
                if (ids && val && ko.unwrap(val.id))
                    ids.splice(ids.indexOf(ko.unwrap(val.id)), 1);
            });
            if (id_obs && ko.isObservable(id_obs)) { id_obs(ids); }
        }
    }
    else {
        if (id_obs) {
            id_obs(newval);
            if (newval && added) {
                value.id(added.id);
                value.name(added.title || added.name);
                value.unique_id(added.unique_id);
            }
            else {
                value.id(null);
                value.name(null);
                value.unique_id(null);
            }

            if (reset){
                var targets = ko.unwrap(bindings().reset);
                if (targets) {
                    if (!Array.isArray(targets)) {
                        targets = [targets];
                    }
                    $.each(targets, function(idx, target) {
                        uly.publish(target + ".reset");
                    });
                }
            }

        }
    }

    //if ($elt.children("input").valid) {
    //    $elt.children("input").valid();
    //}
}

var searchbox_counter = 1000;
ko.bindingHandlers.searchbox = {
    init: function(elt, va, bindings, model, context) {
        var value = ko.unwrap(va()),
            entity = ko.unwrap(bindings().entity);

        var js_value = ko.toJS(value),
            $elt = $(elt);

        var query_ = {_type:entity};

        var tot = 0, search = null;
        var id_obs = bindings().id_obs;
        var reset = "reset" in bindings();
        var search_field = bindings().search_field || "title_t";
        var searchbox_id = ++searchbox_counter;
        var search_model = {
            "expanded": ko.observable(false),
            "details": {
                "subtitle": ko.observable(null),
                "body": ko.observable(null)
            },
            "search_value": value.name,
            "expand_search": function() { 
                var value = ko.unwrap(va());
                uly.api.get_entity(ko.unwrap(value.unique_id)).then(function(result) {
                    search_model.expanded(true); 
                    search_model.details.subtitle(result.subtitle);
                    search_model.details.body(result.snippet);
                });
            },
            "collapse_search": function() { search_model.expanded(false); },
            "execute_search": function() {
                var fq = ko.unwrap(bindings().fq);
                if($.trim(fq))
                    fq = new uly.fq_parser(context).parse(fq);
                else fq = "";
                var search_options = {
                    inherit_parent_field: ko.unwrap(bindings().inherit_parent_field),
                    inherit_path: ko.unwrap(bindings().inherit_path),
                    "filters":fq
                };
                uly.dialogs.search_entity(entity, _("searchbox_searchbox_module_search", "Search {0}").format(entity), "", _("searchbox_searchbox_module_select", "Select"), _("searchbox_searchbox_module_cancel", "Cancel"), search_options)
                    .then(function(result) {
                        on_value_selected({"added":result, "val": result.id}, null, false, id_obs, ko.unwrap(va()), reset, bindings, $elt);
                        $elt.children("input").focus();
                    }, function(error) {
                        $elt.children("input").focus();
                    });
            },
            "clear_search": function() {
                on_value_selected({"removed":value, "val": null}, null, false, id_obs, ko.unwrap(va()), reset, bindings, $elt);
            },
            "create_action": function(ev, action) {
                var $elt = $(ev.target);
                uly.reset_timeout();
                var action_funk = uly.actions[action] || uly.doc_actions[action];
                if(action_funk) {
                    ev.cancelBubble = true;
                    if (ev.stopPropagation) {
                        ev.stopPropagation();
                    }
                    search_model.spinner(true)
                    action_funk(ev, search_model).then((result) => {
                        on_value_selected({"added":result, "val": result.id}, null, false, id_obs, ko.unwrap(va()), reset, bindings, $elt);
                        $elt.children("input").focus();
                    }, (error) => { $elt.children("input").focus(); }).always(()=>{ search_model.spinner(false) });
                }
            },
            "spinner": ko.observable(false)
        };
        $elt.find("input.search-input").on("keyup", function(e) {
            if (e.keyCode == 13 || e.keyCode == 32) {
                e.preventDefault();
                e.stopPropagation();
                search_model.execute_search();
                return false;
            } else if (e.keyCode == 27) {
                e.preventDefault();
                e.stopPropagation();
                search_model.clear_search();
                return false;
            }
        }).click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            search_model.execute_search();
            return false;
        });
        ko.applyBindingsToDescendants(context.createChildContext(search_model), elt);
        uly.subscribe(ko.unwrap(bindings().name) + ".reset", function(topic, state) {
            on_value_selected({"removed": ko.unwrap(va()), "val": null}, null, false, id_obs, ko.unwrap(va()), reset, bindings, $elt);
        }, elt);
        return {"controlsDescendantBindings": true};
    }
};

ko.bindingHandlers.multisearchbox = {
    init: function(elt, va, bindings, model, context) {
        var value = ko.unwrap(va()),
            entity = ko.unwrap(bindings().entity);

        var js_value = ko.toJS(value),
            $elt = $(elt);

        var query_ = {_type:entity};

        var tot = 0, search = null;
        var id_obs = bindings().id_obs;
        var reset = "reset" in bindings();
        var search_field = bindings().search_field || "title_t";
        var searchbox_id = ++searchbox_counter;
        var search_model = {
            "search_value": va(),
            "execute_search": function() {
                var fq = ko.unwrap(bindings().fq);
                if($.trim(fq))
                    fq = new uly.fq_parser(context).parse(fq);
                else fq = "";
                uly.dialogs.search_entity(entity, _("searchbox_searchbox_module_search", "Search {0}").format(entity), "", _("searchbox_searchbox_module_select", "Select"), _("searchbox_searchbox_module_cancel", "Cancel"), {"filters":fq})
                    .then(function(result) {
                        on_value_selected({"added":result, "val": result.id}, null, true, id_obs, va(), reset, bindings, $elt);
                        $elt.children("select").focus();
                    }, function(error) {
                        $elt.children("select").focus();
                    });
            },
            "clear_search": function() {
                on_value_selected({"removed":value, "val": null}, null, true, id_obs, va(), reset, bindings, $elt);
            }
        };
        $elt.children("input").on("keyup", function(e) {
            if (e.keyCode == 13 || e.keyCode == 32) {
                e.preventDefault();
                e.stopPropagation();
                search_model.execute_search();
                return false;
            } else if (e.keyCode == 27) {
                e.preventDefault();
                e.stopPropagation();
                search_model.clear_search();
                return false;
            }
        }).click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            search_model.execute_search();
            return false;
        });
        ko.applyBindingsToDescendants(context.createChildContext(search_model), elt);
        uly.subscribe(ko.unwrap(bindings().name) + ".reset", function(topic, state) {
            on_value_selected({"removed": ko.unwrap(va()), "val": null}, null, true, id_obs, ko.unwrap(va()), reset, bindings, $elt);
        }, elt);
        return {"controlsDescendantBindings": true};
    }
};


ko.bindingHandlers.tagsinput = {
    init: function(elt, va, allbindings, model, context) {
        $(elt).tagsinput({"itemValue": "id", "itemText": "name"});
        $(elt).parent().children(".bootstrap-tagsinput").addClass("form-control");
        $(elt).on("itemRemoved", function(ev) {
            var item = ev.item;
            var items = ko.unwrap(va());
            for (var i=items.length-1;i>=0;--i) {
                if (ko.unwrap(items[i].id) == ko.unwrap(item.id))
                    va().splice(i,1);
            }
        });
    },
    update: function(elt, va, allbindings, model, context) {
        $(elt).tagsinput("removeAll");
        var id_obs = ko.unwrap(allbindings().id_obs);
        $.each(ko.unwrap(va()), function(idx, v) {
            var nv = ko.toJS(v);
            if (!nv.name) { nv.name = nv.title; }
            $(elt).tagsinput("add", ko.toJS(nv));
        });
    }
};

